import { createFileRoute, notFound } from '@tanstack/react-router';

import { envConfigs } from '@/config';
import { m } from '@/paraglide/messages.js';
import { getLocale, localizeUrl } from '@/paraglide/runtime.js';
import { HotelLobbyPage } from '@/blocks/hotel-lobby';

export const Route = createFileRoute('/ai-livestream')({
  // Hidden: left over from the Hotel Lobby AI project, not part of CADCraft.
  beforeLoad: () => {
    throw notFound();
  },
  loader: () => ({ locale: getLocale() }),
  head: ({ loaderData }) => {
    const locale = loaderData?.locale ?? 'en';
    const title = m['common.metadata.title']({}, { locale });
    const description = m['common.metadata.description']({}, { locale });
    return {
      meta: [
        { title },
        { name: 'description', content: description },
        { name: 'robots', content: 'noindex,follow' },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { property: 'og:type', content: 'website' },
        {
          property: 'og:image',
          content: `${envConfigs.app_url}/imgs/generated/hotel-lobby-duet.png`,
        },
        { name: 'twitter:card', content: 'summary_large_image' },
      ],
      links: [
        {
          rel: 'canonical',
          href: localizeUrl(`${envConfigs.app_url}/ai-livestream`, { locale })
            .href,
        },
      ],
    };
  },
  component: HotelLobbyPage,
});
